import { render, staticRenderFns } from "./releasing.vue?vue&type=template&id=59fec3d2&scoped=true"
import script from "./releasing.vue?vue&type=script&lang=js"
export * from "./releasing.vue?vue&type=script&lang=js"
import style0 from "./releasing.vue?vue&type=style&index=0&id=59fec3d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fec3d2",
  null
  
)

export default component.exports